import {
  ROOT_PATH,
  STORY_TREE_PATH,
  COMUNICAR_STORY_TREE_HOME_ROOT_PATH
} from 'routes/paths'
import type { LocationType } from './types'
import type { UserState } from 'utils/hooks/use-userInfo'

function getRedirectLocation(
  user: UserState,
  currentPath: string
): LocationType {
  if (
    (!user?.featureToggles?.storyTree ||
      (user?.teacher && user?.featureToggles?.storyTree)) &&
    [STORY_TREE_PATH, COMUNICAR_STORY_TREE_HOME_ROOT_PATH].includes(currentPath)
  ) {
    return {
      pathname: ROOT_PATH
    }
  }

  return {
    pathname: ''
  }
}

export default {
  getRedirectLocation
}
